import { t as e } from "./cn.CnaYSZq4.js";
import { n as t } from "./index.es.rgGZEnOs.js";
import { Channel as n } from "../TVListing/components/Channel.es.js";
import { Day as r } from "../TVListing/components/Day.es.js";
import { EndTime as i } from "../TVListing/components/EndTime.es.js";
import { Time as a } from "../TVListing/components/Time.es.js";
import { Title as o } from "../TVListing/components/Title.es.js";
import { useEffect as s, useMemo as c } from "react";
import { Rows4Icon as l, XIcon as u } from "lucide-react";
import { Fragment as d, jsx as f, jsxs as p } from "react/jsx-runtime";
import { Node as m, Transforms as h } from "slate";
import { useSlate as g } from "slate-react";
import { createPortal as _ } from "react-dom";
//#region lib/TVListing/componentEntry.tsx
var v = () => ({
	class: "block",
	component: T,
	children: E.map((e) => ({
		type: e,
		class: "text",
		component: k(e),
		constraints: {
			allowBreak: !1,
			allowSoftBreak: !1
		}
	}))
}), y = (e) => {
	if (!e || e.type !== "tt/tv-listing") return !1;
	let t = e.children ?? [];
	if (t.length === 0) return !1;
	let n = new Set(t.map((e) => e.type.replace("tt/tv-listing/", "")));
	return D.every((e) => n.has(e)) ? t.every((t) => {
		if (t.type.replace("tt/tv-listing/", "") === "channel") {
			let t = (e.properties?.channel)?.trim() ?? "", n = (e.properties?.uri)?.trim() ?? "";
			return !!t && !!n;
		}
		return m.string(t).trim().length > 0;
	}) : !1;
}, b = "button, input, textarea, select, [role=\"combobox\"], [role=\"option\"]", x = () => [{
	id: crypto.randomUUID(),
	class: "block",
	type: "tt/tv-listing",
	properties: {},
	children: A(E)
}], S = ({ options: e, onConfirm: n, onCancel: r }) => {
	let i = c(x, []), a = c(() => [{
		class: "block",
		name: "tt/tv-listing",
		options: {
			...e,
			inDialog: !0
		},
		componentEntry: v()
	}], [e]);
	return s(() => {
		let e = (e) => {
			e.key === "Escape" && (e.preventDefault(), r());
		};
		return document.addEventListener("keydown", e, !0), () => document.removeEventListener("keydown", e, !0);
	}, [r]), /* @__PURE__ */ f(C, {
		onCancel: r,
		children: /* @__PURE__ */ p(t.Root, {
			value: i,
			plugins: a,
			debounce: 1,
			children: [/* @__PURE__ */ f(t.Editable, {
				autoFocus: "start",
				className: "outline-none"
			}), /* @__PURE__ */ f(w, {
				onConfirm: n,
				onCancel: r
			})]
		})
	});
}, C = ({ onCancel: e, children: t }) => /* @__PURE__ */ f("div", {
	className: "fixed inset-0 z-50 flex items-center justify-center bg-black/50",
	onMouseDown: e,
	children: /* @__PURE__ */ p("div", {
		className: "bg-white dark:bg-slate-900 text-black dark:text-white rounded shadow-lg w-[480px] max-w-full",
		onMouseDown: (e) => e.stopPropagation(),
		children: [/* @__PURE__ */ f("div", {
			className: "p-3 border-b dark:border-slate-700",
			children: /* @__PURE__ */ f("h2", {
				className: "text-sm font-semibold",
				children: "Lägg till tablåinformation"
			})
		}), /* @__PURE__ */ f("div", {
			className: "p-3 space-y-3",
			children: t
		})]
	})
}), w = ({ onConfirm: e, onCancel: t }) => {
	let n = g().children[0], r = y(n);
	return s(() => {
		let t = (t) => {
			t.key !== "Enter" || t.shiftKey || t.ctrlKey || t.altKey || t.metaKey || t.target instanceof HTMLElement && t.target.closest(b) || !r || !n || (t.preventDefault(), t.stopPropagation(), e(n));
		};
		return document.addEventListener("keydown", t, !0), () => document.removeEventListener("keydown", t, !0);
	}, [
		r,
		n,
		e
	]), /* @__PURE__ */ p("div", {
		className: "flex justify-end gap-2 pt-2",
		children: [/* @__PURE__ */ f("button", {
			type: "button",
			onClick: t,
			className: "px-3 py-1 text-sm border rounded hover:bg-slate-100 dark:hover:bg-slate-800 dark:border-slate-700",
			children: "Avbryt"
		}), /* @__PURE__ */ f("button", {
			type: "button",
			disabled: !r || !n,
			onClick: () => n && e(n),
			className: "px-3 py-1 text-sm bg-blue-600 hover:bg-blue-700 text-white rounded disabled:opacity-50 disabled:cursor-not-allowed",
			children: "Lägg till"
		})]
	});
}, T = ({ editor: t, children: n, element: r, options: i }) => {
	let a = !!t && !!r && t.children[0]?.id === r.id, o = !!i?.inDialog;
	if (r?.properties?.uninitialized) {
		let e = () => t.children.findIndex((e) => e.id === r.id);
		return /* @__PURE__ */ p(d, { children: [/* @__PURE__ */ f("span", {
			style: { display: "none" },
			children: n
		}), _(/* @__PURE__ */ f(S, {
			options: i,
			onConfirm: (n) => {
				let r = e();
				r < 0 || (h.removeNodes(t, { at: [r] }), h.insertNodes(t, n, { at: [r] }), h.select(t, {
					anchor: {
						offset: 0,
						path: [
							r,
							0,
							0
						]
					},
					focus: {
						offset: 0,
						path: [
							r,
							0,
							0
						]
					}
				}));
			},
			onCancel: () => {
				let n = e();
				n < 0 || h.removeNodes(t, { at: [n] });
			}
		}), document.body)] });
	}
	return /* @__PURE__ */ p("div", {
		className: e("border rounded", !a && !o && "mt-3"),
		children: [/* @__PURE__ */ p("div", {
			contentEditable: !1,
			draggable: !o,
			className: e("flex flex-nowrap justify-between items-center basis-full p-2 bg-slate-300 dark:bg-slate-900", !o && "cursor-grab"),
			children: [/* @__PURE__ */ p("div", {
				className: "flex items-end gap-2",
				children: [/* @__PURE__ */ f(l, { size: 15 }), /* @__PURE__ */ f("span", {
					className: "text-xs font-semibold",
					children: "Tablåinformation"
				})]
			}), !o && /* @__PURE__ */ f("div", {
				className: "hover:cursor-pointer hover:bg-slate-200 dark:hover:bg-gray-700 p-1 rounded -my-1",
				onMouseDown: (e) => {
					e.preventDefault(), e.stopPropagation();
					let n = t.children.findIndex((e) => e.id === r.id);
					n > -1 && h.removeNodes(t, { at: [n] });
				},
				children: /* @__PURE__ */ f(u, {
					size: 15,
					className: "text-black dark:text-white"
				})
			})]
		}), /* @__PURE__ */ f("div", {
			className: "px-2",
			children: n
		})]
	});
}, E = [
	"title",
	"channel",
	"day",
	"time",
	"end_time"
], D = ["channel"], O = {
	title: o,
	channel: n,
	day: r,
	time: a,
	end_time: i
}, k = (e) => O[e], A = (e) => e.map((e) => ({
	id: crypto.randomUUID(),
	class: "text",
	type: `tt/tv-listing/${e}`,
	children: [{ text: "" }]
}));
//#endregion
export { T as a, v as c, k as i, D as n, S as o, A as r, y as s, E as t };
